'use strict';

import angular from 'angular';


export default class SignupController {
  errors = {};
  submitted = false;

  /*@ngInject*/
  constructor(Auth, $state, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.$state = $state;

    const generalConfig = Config.getModuleConfig(Config.Modules.General);
    const signUpConfig = Config.getModuleConfig(Config.Modules.SignUp);
    const profileConfig = Config.getModuleConfig(Config.Modules.Profile);

    this.buildings = generalConfig.getClientBuildings();
    this.unitNumbersByBuilding = generalConfig.getClientUnits();

    this.signUpInfo = signUpConfig.getInfoTexts();

    this.requiresResidencyStatus = signUpConfig.isResidencyRelationsRequired();

    this.associationInfo = signUpConfig.getAssociationInfo();
    this.associations = generalConfig.getClientAssociations();

    this.residencyRelationsCheckboxText = signUpConfig.getResidencyRelationsConfig().checkboxText
      || 'I have connections (like ownership etc.) to an apartment';

    this.residencyRelationType = profileConfig.getResidencyRelationTypes();
    this.defaultResidencyRelationType = profileConfig.getDefaultResidencyRelationType();

    this.user = {
      email: '',
      password: '',
      residencyRelations: [
        {
          unit: '',
          building: '',
          type: this.defaultResidencyRelationType
        }
      ],
      hasResidencyRelations: false,
      newsletter: true
    };
  }

  addNewResidency() {
    if (!this.user.hasResidencyRelations)
      return;

    this.user.residencyRelations.push({
      unit: '',
      building: '',
      type: this.defaultResidencyRelationType
    });
  }

  removeResidency(idx) {
    if (!this.user.hasResidencyRelations)
      return;

    this.user.residencyRelations.splice(idx,1);
  }

  getUnitsByBuilding(building) {
    // If there is no building selected, return an empty array
    if (typeof building == 'undefined')
      return [];

    return this.unitNumbersByBuilding[building];
  }

  register(form) {
    this.submitted = true;

    if(form.$valid) {
      return this.Auth.createUser(this.user)
        .then(() => {
          // Account created, redirect to home
          this.$state.go('home');
        })
        .catch(err => {
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          if (err.name) {
            angular.forEach(err.errors, (error, field) => {
              form[field].$setValidity('mongoose', false);
              this.errors[field] = error.message;
            });
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js